export function encryptNumber(num, base = 992832) {
  return num * base
}

export function decryptNumber(encryptedNum, base = 992832) {
  return encryptedNum / base
}
